import styled from 'styled-components';
import StyleData from '../../utilities/StyleData';

export const Divider = styled.div`
  width: 100%;
  border-bottom: 1px solid ${StyleData.color.smoothGrey};
`;
